export const defaultEpisodeTypeFiltersState = {
  live: true,
  compilation: true,
  wfh: true,
  office: true,
};

export const defaultSearchFiltersState = {
  episode: true,
  title: true,
  description: true,
  words: true,
};
